import { render, staticRenderFns } from "./MeetingApprovalList.vue?vue&type=template&id=12bab878&scoped=true&"
import script from "./MeetingApprovalList.vue?vue&type=script&lang=ts&"
export * from "./MeetingApprovalList.vue?vue&type=script&lang=ts&"
import style0 from "./MeetingApprovalList.vue?vue&type=style&index=0&id=12bab878&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bab878",
  null
  
)

export default component.exports